module.exports = __webpack_public_path__ + "img/caterer.6228a9e0.svg";